import {IAIApiCall, IRestApiService} from "../types";


class AIApiCall implements IAIApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  sendQuery = (query: string, tempId: string, ownerId: string): Promise<any> => {
    const url = 'ai/ai-query';
    return this.restApiService.post(url, { query, tempId, ownerId });
  };

  getResults = (tempId: string): Promise<any> => {
    const url = `ai/get-results/${tempId}`;
    return this.restApiService.get(url);
  };
}

export default AIApiCall;
